import XRegExp from 'xregexp'

export const passwordRegex =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*([^\s\w]|_)).{8,48}$/

export const emailRegex =
  // eslint-disable-next-line security/detect-unsafe-regex
  /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/

export const nameRegex = XRegExp("^[\\p{L}-., ']{1,50}$")

export const pathTemplateRegex = /^(.*){lang}(.*)(\.json|\.xml|\.strings)$/
